/* StudioSoie · Pages collection (ss-collection-page v4) et page de recherche
   - tri : redirection ?sort_by=…
   - filtres par facettes (tiroir) : formulaire → URL → la section est re-rendue côté serveur (?section_id=) et
     [data-ssp-results] + le corps du tiroir sont remplacés ; URL mise à jour (history.replaceState) ; sans JS le
     formulaire GET fonctionne tel quel.
   - « Voir plus » : charge la page suivante en arrière-plan et ajoute les cartes (pagination classique conservée sans JS)
   - deuxième image des cartes chargée au survol seulement ; étoiles Judge.me ré-hydratées ; pastilles de coloris. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ssp]');
  if (!root) { return; }
  var section = root.closest('.shopify-section');
  var sectionId = section && section.id ? section.id.replace('shopify-section-', '') : null;

  /* ---- Deuxième image au survol ---- */
  function armCard(card) {
    if (card.__ssArmed) { return; }
    card.__ssArmed = true;
    var second = card.querySelector('img.is-second[data-src]');
    if (!second) { return; }
    card.classList.add('has-second');
    var load = function () {
      if (!second.getAttribute('data-src')) { return; }
      second.src = second.getAttribute('data-src');
      var ss = second.getAttribute('data-srcset'); if (ss) { second.srcset = ss; }
      second.removeAttribute('data-src'); second.removeAttribute('data-srcset');
    };
    card.addEventListener('mouseenter', load, { once: true });
    card.addEventListener('focus', load, { once: true });
    card.addEventListener('touchstart', load, { once: true, passive: true });
  }
  function armAll(scope) { (scope || root).querySelectorAll('[data-ssp-card]').forEach(armCard); }

  /* ---- Pastilles de coloris (délégué : survit aux remplacements) ---- */
  function selectSwatch(btn) {
    var card = btn.closest('[data-ssp-card]'); if (!card) { return; }
    var first = card.querySelector('img.is-first');
    var src = btn.getAttribute('data-img');
    if (first && src && first.getAttribute('src') !== src) {
      first.setAttribute('src', src);
      var ss = btn.getAttribute('data-srcset'); if (ss) { first.setAttribute('srcset', ss); } else { first.removeAttribute('srcset'); }
      card.classList.remove('has-second');
    }
    var vid = btn.getAttribute('data-variant');
    if (vid) {
      card.querySelectorAll('a[data-ssp-link], a.ssp-card__dot--more').forEach(function (a) {
        try { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('variant', vid); a.setAttribute('href', u.pathname + u.search); } catch (e) {}
      });
    }
    card.querySelectorAll('[data-ssp-swatch]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ssp-swatch]');
    if (!b) { return; }
    e.preventDefault(); e.stopPropagation();
    selectSwatch(b);
  });
  root.addEventListener('mouseover', function (e) {
    var b = e.target.closest && e.target.closest('[data-ssp-swatch]');
    if (!b || !window.matchMedia('(hover: hover)').matches) { return; }
    var card = b.closest('[data-ssp-card]'), first = card && card.querySelector('img.is-first'), src = b.getAttribute('data-img');
    if (!first || !src) { return; }
    if (!first.getAttribute('data-orig')) { first.setAttribute('data-orig', first.getAttribute('src')); first.setAttribute('data-orig-srcset', first.getAttribute('srcset') || ''); }
    first.setAttribute('src', src); var ss = b.getAttribute('data-srcset'); if (ss) { first.setAttribute('srcset', ss); }
  });
  root.addEventListener('mouseout', function (e) {
    var b = e.target.closest && e.target.closest('[data-ssp-swatch]');
    if (!b) { return; }
    var card = b.closest('[data-ssp-card]'), first = card && card.querySelector('img.is-first');
    if (!first || b.getAttribute('aria-pressed') === 'true') { if (first) { first.removeAttribute('data-orig'); first.removeAttribute('data-orig-srcset'); } return; }
    var pressed = card.querySelector('[data-ssp-swatch][aria-pressed="true"]');
    var back = pressed && pressed.getAttribute('data-img') ? pressed.getAttribute('data-img') : first.getAttribute('data-orig');
    var backSet = pressed && pressed.getAttribute('data-srcset') ? pressed.getAttribute('data-srcset') : first.getAttribute('data-orig-srcset');
    if (back) { first.setAttribute('src', back); if (backSet) { first.setAttribute('srcset', backSet); } }
  });

  /* ---- Résultats : tri + « Voir plus » (re-liés après chaque remplacement) ---- */
  function bindResults() {
    armAll();
    var sel = root.querySelector('[data-ssp-sort]');
    if (sel && !sel.__ssBound) {
      sel.__ssBound = true;
      var url = new URL(location.href);
      sel.value = url.searchParams.get('sort_by') || sel.getAttribute('data-default') || 'manual';
      sel.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page');
        if (sectionId && root.querySelector('[data-ssp-results]')) { loadUrl(u.toString(), { keepOpen: false }); } else { location.href = u.toString(); }
      });
    }
    var grid = root.querySelector('[data-ssp-grid]');
    var more = root.querySelector('[data-ssp-more]');
    var pager = root.querySelector('.ssp-pager');
    if (grid && more && !more.__ssBound) {
      more.__ssBound = true;
      var btn = more.querySelector('button');
      var countEl = more.querySelector('[data-ssp-shown]');
      var bar = more.querySelector('.ssp-more__bar');
      var total = parseInt(more.getAttribute('data-total'), 10) || 0;
      if (pager) { pager.classList.add('is-js'); }
      var updateCount = function () {
        var shown = grid.querySelectorAll('[data-ssp-card]').length;
        if (countEl) { countEl.textContent = countEl.getAttribute('data-tpl').replace('[shown]', shown).replace('[total]', total); }
        if (bar && total) { bar.style.setProperty('--ssp-progress', Math.min(100, Math.round(shown / total * 100)) + '%'); }
        return shown;
      };
      updateCount();
      btn.addEventListener('click', function () {
        var next = more.getAttribute('data-next');
        if (!next) { return; }
        btn.disabled = true;
        fetch(next, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('[data-ssp-grid] [data-ssp-card]');
            var frag = document.createDocumentFragment();
            cards.forEach(function (c) { c.querySelectorAll('img[loading="eager"]').forEach(function (i) { i.loading = 'lazy'; i.removeAttribute('fetchpriority'); }); frag.appendChild(c); });
            var first = frag.firstElementChild;
            grid.appendChild(frag);
            armAll(grid);
            var nextMore = doc.querySelector('[data-ssp-more]');
            var nextUrl = nextMore ? nextMore.getAttribute('data-next') : '';
            if (nextUrl) { more.setAttribute('data-next', nextUrl); btn.disabled = false; }
            else { more.removeAttribute('data-next'); btn.hidden = true; }
            updateCount();
            try { history.replaceState(null, '', next); } catch (e) {}
            hydrateBadges();
            if (first && first.focus) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: true }); }
          })
          .catch(function () { btn.disabled = false; if (pager) { pager.classList.remove('is-js'); } });
      });
    }
  }
  function hydrateBadges() { if (window.jdgm && typeof window.jdgm.batchRenderBadges === 'function') { try { window.jdgm.batchRenderBadges(); } catch (e) {} } }
  bindResults();

  /* ---- Filtres par facettes ---- */
  var drawer = root.querySelector('[data-ssp-filters]');
  var lastFocus = null;
  function openDrawer() {
    drawer = root.querySelector('[data-ssp-filters]'); if (!drawer) { return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('ssp-filters-open');
    root.querySelectorAll('[data-ssp-filter-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = drawer.querySelector('.ssp-filters__panel'); if (panel) { setTimeout(function () { panel.focus({ preventScroll: true }); }, 60); }
  }
  function closeDrawer() {
    drawer = root.querySelector('[data-ssp-filters]'); if (!drawer) { return; }
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ssp-filters-open');
    root.querySelectorAll('[data-ssp-filter-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function buildUrl(form) {
    var u = new URL(form.getAttribute('action') || location.pathname, location.origin);
    var p = new URLSearchParams();
    var sort = form.querySelector('[name="sort_by"]');
    var cur = new URL(location.href).searchParams.get('sort_by');
    if (sort && sort.value) { p.set('sort_by', sort.value); } else if (cur) { p.set('sort_by', cur); }
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      if (!cb.checked) { return; }
      p.append(cb.name, cb.value);
      var alt = cb.getAttribute('data-alt-value'); if (alt) { p.append(cb.name, alt); }
    });
    form.querySelectorAll('input[type="number"]').forEach(function (inp) {
      var v = (inp.value || '').trim(); if (v !== '' && !isNaN(parseFloat(v))) { p.set(inp.name, String(Math.max(0, parseFloat(v)))); }
    });
    u.search = p.toString();
    return u.toString();
  }
  var loading = null;
  function loadUrl(url, opts) {
    opts = opts || {};
    if (!sectionId) { location.href = url; return; }
    var results = root.querySelector('[data-ssp-results]');
    if (results) { results.classList.add('is-loading'); results.setAttribute('aria-busy', 'true'); }
    var fetchUrl = new URL(url, location.origin); fetchUrl.searchParams.set('section_id', sectionId);
    var token = loading = {};
    fetch(fetchUrl.toString(), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        if (token !== loading) { return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newResults = doc.querySelector('[data-ssp-results]');
        var oldResults = root.querySelector('[data-ssp-results]');
        if (newResults && oldResults) { oldResults.replaceWith(newResults); }
        /* corps du tiroir (compteurs, cases) + bouton « Voir les N pièces » + pastille du bouton Filtrer */
        var newBody = doc.querySelector('[data-ssp-filter-body]'), oldBody = root.querySelector('[data-ssp-filter-body]');
        if (newBody && oldBody) {
          var openStates = {}; oldBody.querySelectorAll('details[data-ssp-f]').forEach(function (d) { openStates[d.getAttribute('data-ssp-f')] = d.open; });
          var scrollTop = oldBody.scrollTop;
          oldBody.innerHTML = newBody.innerHTML;
          oldBody.querySelectorAll('details[data-ssp-f]').forEach(function (d) { var k = d.getAttribute('data-ssp-f'); if (k in openStates) { d.open = openStates[k]; } });
          oldBody.scrollTop = scrollTop;
        }
        var newApply = doc.querySelector('[data-ssp-filter-apply]'), oldApply = root.querySelector('[data-ssp-filter-apply]');
        if (newApply && oldApply) { oldApply.textContent = newApply.textContent; }
        var newTitle = doc.querySelector('.ssp-filters__title'), oldTitle = root.querySelector('.ssp-filters__title');
        if (newTitle && oldTitle) { oldTitle.innerHTML = newTitle.innerHTML; }
        var newClear = doc.querySelector('[data-ssp-filter-clear]'), oldClear = root.querySelector('.ssp-filters__foot [data-ssp-filter-clear]');
        if (newClear && oldClear) { oldClear.setAttribute('href', newClear.getAttribute('href')); }
        try { history.replaceState(null, '', url); } catch (e) {}
        bindResults(); hydrateBadges();
        if (opts.keepOpen === false) { closeDrawer(); }
        if (opts.scroll) { var top = root.querySelector('.ssp-toolbar'); if (top) { top.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
      })
      .catch(function () { location.href = url; });
  }
  var priceTimer = null;
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ssp-filter-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-ssp-filter-close]')) { e.preventDefault(); closeDrawer(); return; }
    var chip = e.target.closest('[data-ssp-chip], [data-ssp-filter-clear]');
    if (chip && chip.getAttribute('href')) { e.preventDefault(); loadUrl(chip.getAttribute('href'), { keepOpen: !!chip.closest('[data-ssp-filters]') }); return; }
    var moreBtn = e.target.closest('[data-ssp-f-more]');
    if (moreBtn) {
      e.preventDefault();
      var det = moreBtn.closest('details'), on = det.classList.toggle('is-expanded');
      moreBtn.textContent = on ? moreBtn.getAttribute('data-less') : moreBtn.getAttribute('data-more');
    }
  });
  root.addEventListener('change', function (e) {
    var form = e.target.closest('[data-ssp-filter-form]'); if (!form) { return; }
    if (e.target.type === 'number') { clearTimeout(priceTimer); priceTimer = setTimeout(function () { loadUrl(buildUrl(form), { keepOpen: true }); }, 500); return; }
    loadUrl(buildUrl(form), { keepOpen: true });
  });
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ssp-filter-form]'); if (!form) { return; }
    e.preventDefault();
    loadUrl(buildUrl(form), { keepOpen: false, scroll: true });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) { closeDrawer(); }
  });
})();
